var render = function render(_c,_vm){return _c('i',_vm._b({staticClass:"tkCrossMark",class:_vm.data.staticClass,style:({
    '--width': `${_vm.props.width}px`,
    '--length': `${_vm.props.length}px`,
  })},'i',(() => ({
      ..._vm.data.attrs,
      /* ルート要素に利用側の scope ID を設定し、利用側の指定する scoped なクラスのスタイル（position などのレイアウト調整）を適用できるようにする */
      /* functional なコンポーネントの場合だけ必要になる特殊処理. :class=data.staticClass も必要 */
      [_vm.parent.$options._scopeId]: '',
  }))(),false))
}
var staticRenderFns = []

export { render, staticRenderFns }